<template>
  <div class="price">
    <p class="discountprice" v-if="$attrs.price.validDiscount">-{{ $attrs.price.calculatedDiscount }}%</p>
    <div class="detailprice">
      <p class="pricepp">pro Person ab</p>
      <p class="newprice">{{ $attrs.price.formattedCurrent }} <span>€</span></p>
    </div>
    <div class="strikeprice" v-if="$attrs.price.validDiscount">
      <p class="price-old">{{ $attrs.price.formattedOld }} <span>€</span></p>
      <span class="strikeprice-info">
              <i class="fa fa-info-circle"></i>
              <span class="strikeprice-text" v-if="$attrs.price.priceSavingsText">
                      {{ $attrs.price.priceSavingsText }}
              </span>
              <span class="strikeprice-text" v-else>
                Nach Ablauf des Aktionszeitraums gültiger Preis des Veranstalters.
              </span>
          </span>
    </div>
  </div>
</template>

<script>


export default {
  name: 'Price',
  data() {
    return {}
  },
  components: {},
  methods: {}
}
</script>

<style lang="scss">
</style>